import { menuClasses } from "@mui/material";
const MuiMenu = {
    defaultProps: {
        PaperProps: {
            elevation: 1
        }
    },
    styleOverrides: {
        root: ({ theme })=>({
                borderRadius: theme.shape.borderRadius,
                [`& .${menuClasses.paper}`]: {
                    minWidth: '161px',
                    backgroundColor: theme.palette.background.default
                }
            })
    }
};
export { MuiMenu };

//# sourceMappingURL=menu-overrides.js.map